import { memo, useCallback, useState } from 'react';

import { useDebounceCallback } from 'usehooks-ts';

import { useCdekWidget } from '@screens/PlacingOrder/ui/CdekWidget/CdekWidget';
import { getCdekCityInfo } from '@shared/api/getCdekCityInfo/getCdekCityInfo';
import { getCdekDeliveryPoints } from '@shared/api/getCdekDeliveryPoints/getCdekDeliveryPoints';
import { getCdekLocationSuggest } from '@shared/api/getCdekLocationSuggest/getCdekLocationSuggest';
import { CdekSuggest } from '@shared/api/getCdekLocationSuggest/types';
import { Input, InputProps } from '@shared/ui/Input';

import cls from './Search.module.scss';

export const Search = memo(() => {
  const { mapRef, setPoints } = useCdekWidget() || {};

  const [suggest, setSuggest] = useState<CdekSuggest[]>([]);
  const [selectSuggest, setSelectSuggest] = useState<CdekSuggest>();

  const [search, setSearch] = useState('');

  const changeSearchLocation = useCallback<NonNullable<InputProps['onChange']>>(async (value) => {
    const res = await getCdekLocationSuggest(value);

    setSuggest(res);
  }, []);

  const debounceChangeSearchLocation = useDebounceCallback(changeSearchLocation, 500);

  const handleChangeSearchLocation = useCallback<NonNullable<InputProps['onChange']>>(
    async (value) => {
      debounceChangeSearchLocation(value);
      setSearch(value);
      setSelectSuggest(undefined);
    },
    [debounceChangeSearchLocation]
  );

  const handleClickSelectSuggest = useCallback(
    (suggest: CdekSuggest) => async () => {
      setSelectSuggest(suggest);
      setSearch(suggest.full_name);

      const [cdekDeliveryPoints, cdekCityInfo] = await Promise.all([
        getCdekDeliveryPoints(suggest.code),
        getCdekCityInfo(suggest.code)
      ]);

      setPoints?.(cdekDeliveryPoints);

      if (cdekCityInfo) {
        setTimeout(() => {
          mapRef?.current?.setCenter([cdekCityInfo.latitude, cdekCityInfo.longitude], 10, {
            duration: 300,
            checkZoomRange: true
          });
        }, 50);
      }
    },
    [mapRef, setPoints]
  );

  return (
    <div className={cls.wrapper}>
      <Input
        variant={'default'}
        label={'Город'}
        placeholder={'Город'}
        value={search}
        onChange={handleChangeSearchLocation}
      />
      {search.length > 2 && !selectSuggest && (
        <div className={cls.result}>
          {suggest.length ? (
            <ul className={cls.list}>
              {suggest.map((item) => {
                const { code, full_name } = item;
                return (
                  <li
                    key={code}
                    className={cls.listItem}
                    onClick={handleClickSelectSuggest(item)}
                  >
                    {full_name}
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className={cls.emptyResult}>Ничего не найдено</div>
          )}
        </div>
      )}
    </div>
  );
});
